import React from 'react';

import { Box, Typography } from '@mui/material';

import { SyncPromoOfferMetricsParams } from '~/services/PromoService';

import SyncOfferMetricsForm from './SyncOfferMetricsForm';

type SyncMetricsTabProps = {
  // Loading state
  offerMetricsLoading: boolean;

  // Handlers
  handleSyncMetricsFormSubmit: (formData: SyncPromoOfferMetricsParams) => void;
};

export default function SyncMetricsTab({ offerMetricsLoading, handleSyncMetricsFormSubmit }: SyncMetricsTabProps) {
  return (
    <>
      <Typography variant="h6" gutterBottom>
        Sync Offer Metrics
      </Typography>
      <Typography variant="body1" gutterBottom>
        This will sync the latest offer metrics from bigquery into svc-promo for a selected region or specific offer
      </Typography>
      <Box mb={3}>
        <SyncOfferMetricsForm onSubmit={handleSyncMetricsFormSubmit} isLoading={offerMetricsLoading} />
      </Box>
    </>
  );
}
